import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	overflow: auto;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 1.5rem;
`;

export const emptyList = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
	background-color: ${color.interface.white};
	border-radius: 5px;
	padding: 2rem;

	> p {
		font-size: 1.4rem;
		font-family: nunito-bold;
	}
`;
